<div *ngIf="languaje === 'en'">
    <li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
        <a class="icon-Shape-10">Service Model</a>
    </li>
    
    <a class="icon-Shape-10 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Service Model</a>
    <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
    
        <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">SERVICE MODEL</h2>
    
        <div class="container" [ngClass]="{'show': show_description1}">
            <p>At the time of requesting any type of protection, the <strong>Miles Member</strong> must communicate through <strong>alle</strong>, our interactive contact tool, using their preferred channel such as chat or voice: Through these channels, you can also present the documentation and/or proof of the case, if necessary.</p>
            <p>If the <strong>Miles Member</strong> coverage includes some type of compensation, it will be reflected in the Member&rsquo;s<strong> Miles</strong> <strong> Care Visa Digital Card</strong>.</p>
            <p>Once the compensation has been processed, the <strong>Miles Member</strong> will receive a confirmation email after the transaction, as well as a detailed description of that compensation.</p>
        </div>
    
    </div>
    </div>
    
    
    <!---------------- START SECTION ESPAÑOL --------------------->
    <!---------------- START SECTION ESPAÑOL --------------------->
    
    <div *ngIf="languaje === 'es'">
        <li class="pill"  [ngClass]="{'active': is_active}" (click)="showContent()">
            <a class="icon-Shape-10">Modelo de Servicio</a>
        </li>
    
        <a class="icon-Shape-10 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Modelo de Servicio</a>
        <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
    
            <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">MODELO DE SERVICIO</h2>
    
            <div class="container" [ngClass]="{'show': show_description1}">
                <p>En el momento de solicitar cualquier tipo de protecci&oacute;n, el usuario de <strong>Miles</strong> deber&aacute; comunicarse a trav&eacute;s de <strong>alle</strong>, nuestra herramienta de contacto interactiva, utilizando su canal preferido como el chat o la voz: A trav&eacute;s de estos canales, tambi&eacute;n podr&aacute; presentar la documentaci&oacute;n y/o prueba del caso, si es necesario.</p>
                <p>Si la cobertura de <strong>Miles</strong> incluye alg&uacute;n tipo de compensaci&oacute;n, &eacute;sta se reflejar&aacute; en la <strong>Miles Visa Digital Card</strong> de los Usuarios.
                </p>
                <p>Una vez procesada la compensaci&oacute;n, el socio <strong>Miles</strong> recibir&aacute; un correo electr&oacute;nico de confirmaci&oacute;n despu&eacute;s de la transacci&oacute;n, as&iacute; como una descripci&oacute;n detallada de dicha compensaci&oacute;n.</p>
            </div>
        </div>
    </div>
    